export default function Privacy() {
    return (
        <div data-testid="privacy-page" className="pt-32 pb-24 mx-auto max-w-[900px] px-6 lg:px-10">
            <span className="text-[11px] uppercase tracking-[0.2em] font-bold text-[#FFD400]">Legal</span>
            <h1 className="mt-2 font-display text-5xl sm:text-6xl font-black tracking-tight">Privacy Policy</h1>
            <p className="mt-3 text-sm text-white/50">Effective Date: July 20, 2026</p>

            <div className="mt-10 space-y-8 text-white/75 leading-relaxed">
                <p>
                    Welcome to <span className="text-white font-semibold">APNI DUKAN TV</span>, operated by APNI DUKAN.
                    Your privacy is important to us. This Privacy Policy explains our current practices regarding your information.
                </p>

                <Section title="1. Information We Collect">
                    <p>
                        At this time, APNI DUKAN TV does not require user registration and does not intentionally collect personal information from visitors.
                    </p>
                    <p className="mt-3">We do not ask for or store personal information such as:</p>
                    <ul className="mt-2 list-disc list-inside space-y-1 text-white/70">
                        <li>Name</li>
                        <li>Email address</li>
                        <li>Phone number</li>
                        <li>Payment information</li>
                        <li>User account details</li>
                    </ul>
                    <p className="mt-3">
                        The only information we may receive is the information you voluntarily provide when contacting us via email.
                    </p>
                </Section>

                <Section title="2. How We Use Your Information">
                    <p>If you choose to contact us by email, we will use the information you provide only to:</p>
                    <ul className="mt-2 list-disc list-inside space-y-1 text-white/70">
                        <li>Respond to your inquiry</li>
                        <li>Provide customer support</li>
                        <li>Communicate regarding your request</li>
                    </ul>
                    <p className="mt-3">
                        We do not sell, rent, or share your personal information with third parties for marketing purposes.
                    </p>
                </Section>

                <Section title="3. Cookies">
                    <p>
                        Currently, APNI DUKAN TV does not use cookies for user tracking or personalized advertising.
                        Your web browser may automatically store basic technical information necessary for website functionality.
                    </p>
                </Section>

                <Section title="4. Third-Party Services">
                    <p>
                        Our platform may contain embedded videos or links to third-party services. These services operate under their own privacy policies, and we encourage users to review them before interacting with those platforms.
                    </p>
                </Section>

                <Section title="5. Data Security">
                    <p>
                        Although we currently collect very little information, we take reasonable measures to protect any communication sent to us.
                    </p>
                </Section>

                <Section title="6. Children's Privacy">
                    <p>
                        APNI DUKAN TV is intended for a general audience. Children should use the platform under the supervision of a parent or guardian.
                    </p>
                </Section>

                <Section title="7. Changes to This Privacy Policy">
                    <p>
                        We may update this Privacy Policy from time to time. Any changes will be posted on this page with an updated effective date.
                    </p>
                </Section>

                <Section title="8. Contact Us">
                    <p>If you have any questions regarding this Privacy Policy, please contact us:</p>
                    <p className="mt-3">
                        <span className="text-white font-semibold">APNI DUKAN</span><br />
                        Email:{" "}
                        <a href="mailto:linkan@yourapnidukan.com" className="text-[#FFD400] hover:underline">
                            linkan@yourapnidukan.com
                        </a>
                    </p>
                </Section>
            </div>
        </div>
    );
}

function Section({ title, children }) {
    return (
        <section>
            <h2 className="font-display font-bold text-2xl text-white mb-3">{title}</h2>
            <div className="text-white/75">{children}</div>
        </section>
    );
}
